import { Injectable, OnDestroy, signal, Signal, WritableSignal } from '@angular/core';

const TRUE_VALUE: string = 'true';

function loadFromLocalStorage(storageKey: string): boolean {
  return localStorage.getItem(storageKey) === TRUE_VALUE;
}

@Injectable()
export class FullscreenToggleService implements OnDestroy {
  protected readonly storageKey = 'ant-table-is-fullscreen';

  private readonly _isFullscreen: WritableSignal<boolean> = signal(loadFromLocalStorage(this.storageKey));
  private eventListener?: (_: StorageEvent) => void;

  constructor() {
    const eventListener = (_: StorageEvent) => {
      this._isFullscreen.set(loadFromLocalStorage(this.storageKey));
    };
    this.eventListener = eventListener;
    window.addEventListener('storage', eventListener);
  }

  ngOnDestroy(): void {
    if (this.eventListener) {
      window.removeEventListener('storage', this.eventListener);
      this.eventListener = undefined;
    }
  }

  public get isFullScreen(): Signal<boolean> {
    return this._isFullscreen.asReadonly();
  }

  public setIsFullscreen(value: boolean): void {
    if (value) {
      localStorage.setItem(this.storageKey, TRUE_VALUE);
    } else {
      localStorage.removeItem(this.storageKey);
    }
    this._isFullscreen.set(value);
  }
}
